var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4"},[_c('v-subheader',[_vm._v("Информация")]),(false)?_c('v-card',{staticClass:"pa-2",attrs:{"elevation":"1"}},[_vm._v(" Client info "),_c('v-card-text',[_vm._v(" text ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }